import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

export type UseUnarchiveJobRolesParams = {
    readonly jobArchitectureId: string;
    readonly jobRoleIds: NonEmptyArray<string>;
};

export type UseUnarchiveJobRolesResult = UseMutationResult<unknown, Error, UseUnarchiveJobRolesParams>;

export const useUnarchiveJobRoles = (): UseUnarchiveJobRolesResult => {
    const { unarchiveJobRoles } = useApplicationFetchers();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ jobArchitectureId, jobRoleIds }: UseUnarchiveJobRolesParams) => {
            const result = await unarchiveJobRoles({
                jobArchitectureId,
                jobRoleIds,
            });

            if (result.isErr) {
                throw result.error;
            }

            return result.value;
        },
        onSuccess: (_, { jobArchitectureId }) => {
            queryClient.invalidateQueries({
                queryKey: jobArchitectureKeys.architecture(jobArchitectureId),
            });
            queryClient.invalidateQueries({
                queryKey: jobArchitectureKeys.architectureDetail(jobArchitectureId),
            });
        },
        throwOnError: false,
    });
};
